import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from '@core/auth/services/auth';
import { User } from '@core/user/services/user';

export const authGuard: CanActivateFn = async (route, state) => {
  const authApi = inject(Auth);
  const userStore = inject(User);

  // Try to refresh user data to validate token
  try {
    const user = await authApi.refreshUserData();
    if (!user) {
      // Token is invalid, redirect to login
      authApi.handleUnauthorized(state.url);
      return false;
    }
    userStore.updateUser(user);
    return true;
  } catch (error) {
    // Error validating token, redirect to login
    authApi.handleUnauthorized(state.url);
    return false;
  }
};
